const initialState = {
  notifications: [],
  loading: false,
  error: null,
};

const notificationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "NOTIFICATIONS_LOADING":
      return { ...state, loading: true };
    case "NOTIFICATIONS_SUCCESS":
      return { ...state, loading: false, notifications: payload };
    case "NOTIFICATIONS_ERROR":
      return { ...state, loading: false, error: payload };
    case "NOTIFICATION_ADD":
      return { ...state, notifications: [...state.notifications, payload] };
    default:
      return state;
  }
};

export default notificationReducer;
